import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const DashBoardLayout = (props) => {
    return (
    <div>
        <Header {...props}/>

        <div>
            {props.children}
        </div>
        
        <Footer {...props}/>
    </div>
  )
};

export default DashBoardLayout;
